import { render, staticRenderFns } from "./nut-introduction.vue?vue&type=template&id=4cbf995d&scoped=true&"
import script from "./nut-introduction.vue?vue&type=script&lang=js&"
export * from "./nut-introduction.vue?vue&type=script&lang=js&"
import style0 from "./nut-introduction.vue?vue&type=style&index=0&id=4cbf995d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbf995d",
  null
  
)

export default component.exports